export const WORLD_CUP_TEAM_CN = {
  ALG: "阿尔及利亚",
  ARG: "阿根廷",
  AUS: "澳大利亚",
  AUT: "奥地利",
  BEL: "比利时",
  BIH: "波黑",
  BRA: "巴西",
  CAN: "加拿大",
  CIV: "科特迪瓦",
  COD: "刚果民主共和国",
  COL: "哥伦比亚",
  CPV: "佛得角",
  CRO: "克罗地亚",
  CUW: "库拉索",
  CZE: "捷克",
  ECU: "厄瓜多尔",
  EGY: "埃及",
  ENG: "英格兰",
  ESP: "西班牙",
  FRA: "法国",
  GER: "德国",
  GHA: "加纳",
  HAI: "海地",
  IRN: "伊朗",
  IRQ: "伊拉克",
  JOR: "约旦",
  JPN: "日本",
  KOR: "韩国",
  KSA: "沙特阿拉伯",
  MAR: "摩洛哥",
  MEX: "墨西哥",
  NED: "荷兰",
  NOR: "挪威",
  NZL: "新西兰",
  PAN: "巴拿马",
  PAR: "巴拉圭",
  POR: "葡萄牙",
  QAT: "卡塔尔",
  RSA: "南非",
  SCO: "苏格兰",
  SEN: "塞内加尔",
  SUI: "瑞士",
  SWE: "瑞典",
  TUN: "突尼斯",
  TUR: "土耳其",
  URY: "乌拉圭",
  USA: "美国",
  UZB: "乌兹别克斯坦",
};

export const WORLD_CUP_TEAM_NAME_CN = {
  Algeria: "阿尔及利亚",
  Argentina: "阿根廷",
  Australia: "澳大利亚",
  Austria: "奥地利",
  Belgium: "比利时",
  "Bosnia-Herzegovina": "波黑",
  Brazil: "巴西",
  Canada: "加拿大",
  "Cape Verde Islands": "佛得角",
  Colombia: "哥伦比亚",
  "Congo DR": "刚果民主共和国",
  Croatia: "克罗地亚",
  "Curaçao": "库拉索",
  Czechia: "捷克",
  Ecuador: "厄瓜多尔",
  Egypt: "埃及",
  England: "英格兰",
  France: "法国",
  Germany: "德国",
  Ghana: "加纳",
  Haiti: "海地",
  Iran: "伊朗",
  Iraq: "伊拉克",
  "Ivory Coast": "科特迪瓦",
  Japan: "日本",
  Jordan: "约旦",
  Mexico: "墨西哥",
  Morocco: "摩洛哥",
  Netherlands: "荷兰",
  "New Zealand": "新西兰",
  Norway: "挪威",
  Panama: "巴拿马",
  Paraguay: "巴拉圭",
  Portugal: "葡萄牙",
  Qatar: "卡塔尔",
  "Saudi Arabia": "沙特阿拉伯",
  Scotland: "苏格兰",
  Senegal: "塞内加尔",
  "South Africa": "南非",
  "South Korea": "韩国",
  Spain: "西班牙",
  Sweden: "瑞典",
  Switzerland: "瑞士",
  Tunisia: "突尼斯",
  Turkey: "土耳其",
  "United States": "美国",
  Uruguay: "乌拉圭",
  Uzbekistan: "乌兹别克斯坦",
};

export const EUROPEAN_LEAGUE_TEAM_TRANSLATIONS = {
  PL: [
    ["ARS", "Arsenal FC", "阿森纳"],
    ["AVL", "Aston Villa FC", "阿斯顿维拉"],
    ["CHE", "Chelsea FC", "切尔西"],
    ["EVE", "Everton FC", "埃弗顿"],
    ["FUL", "Fulham FC", "富勒姆"],
    ["LIV", "Liverpool FC", "利物浦"],
    ["MCI", "Manchester City FC", "曼城"],
    ["MUN", "Manchester United FC", "曼联"],
    ["NEW", "Newcastle United FC", "纽卡斯尔联"],
    ["SUN", "Sunderland AFC", "桑德兰"],
    ["TOT", "Tottenham Hotspur FC", "托特纳姆热刺"],
    ["HUL", "Hull City AFC", "赫尔城"],
    ["LEE", "Leeds United FC", "利兹联"],
    ["IPS", "Ipswich Town FC", "伊普斯维奇"],
    ["NOT", "Nottingham Forest FC", "诺丁汉森林"],
    ["CRY", "Crystal Palace FC", "水晶宫"],
    ["BHA", "Brighton & Hove Albion FC", "布莱顿"],
    ["BRE", "Brentford FC", "布伦特福德"],
    ["BOU", "AFC Bournemouth", "伯恩茅斯"],
    ["COV", "Coventry City FC", "考文垂"],
  ],
  PD: [
    ["ATH", "Athletic Club", "毕尔巴鄂竞技"],
    ["ATL", "Club Atlético de Madrid", "马德里竞技"],
    ["OSA", "CA Osasuna", "奥萨苏纳"],
    ["ESP", "RCD Espanyol de Barcelona", "西班牙人"],
    ["FCB", "FC Barcelona", "巴塞罗那"],
    ["GET", "Getafe CF", "赫塔菲"],
    ["MAL", "Málaga CF", "马拉加"],
    ["RMA", "Real Madrid CF", "皇家马德里"],
    ["RAY", "Rayo Vallecano de Madrid", "巴列卡诺"],
    ["LEV", "Levante UD", "莱万特"],
    ["BET", "Real Betis Balompié", "皇家贝蒂斯"],
    ["RSO", "Real Sociedad de Fútbol", "皇家社会"],
    ["VIL", "Villarreal CF", "比利亚雷亚尔"],
    ["VAL", "Valencia CF", "瓦伦西亚"],
    ["ALA", "Deportivo Alavés", "阿拉维斯"],
    ["ELC", "Elche CF", "埃尔切"],
    ["CEL", "RC Celta de Vigo", "塞尔塔"],
    ["SEV", "Sevilla FC", "塞维利亚"],
    ["DEP", "RC Deportivo La Coruña", "拉科鲁尼亚"],
    ["SAN", "Real Racing Club de Santander", "桑坦德竞技"],
  ],
  SA: [
    ["MIL", "AC Milan", "AC米兰"],
    ["FIO", "ACF Fiorentina", "佛罗伦萨"],
    ["ROM", "AS Roma", "罗马"],
    ["ATA", "Atalanta BC", "亚特兰大"],
    ["BOL", "Bologna FC 1909", "博洛尼亚"],
    ["CAG", "Cagliari Calcio", "卡利亚里"],
    ["GEN", "Genoa CFC", "热那亚"],
    ["INT", "FC Internazionale Milano", "国际米兰"],
    ["JUV", "Juventus FC", "尤文图斯"],
    ["LAZ", "SS Lazio", "拉齐奥"],
    ["PAR", "Parma Calcio 1913", "帕尔马"],
    ["NAP", "SSC Napoli", "那不勒斯"],
    ["UDI", "Udinese Calcio", "乌迪内斯"],
    ["VEN", "Venezia FC", "威尼斯"],
    ["FRO", "Frosinone Calcio", "弗罗西诺内"],
    ["SAS", "US Sassuolo Calcio", "萨索洛"],
    ["TOR", "Torino FC", "都灵"],
    ["USL", "US Lecce", "莱切"],
    ["MON", "AC Monza", "蒙扎"],
    ["COM", "Como 1907", "科莫"],
  ],
  BL1: [
    ["KOE", "1. FC Köln", "科隆"],
    ["TSG", "TSG 1899 Hoffenheim", "霍芬海姆"],
    ["B04", "Bayer 04 Leverkusen", "勒沃库森"],
    ["BVB", "Borussia Dortmund", "多特蒙德"],
    ["FCB", "FC Bayern München", "拜仁慕尼黑"],
    ["S04", "FC Schalke 04", "沙尔克04"],
    ["HSV", "Hamburger SV", "汉堡"],
    ["VFB", "VfB Stuttgart", "斯图加特"],
    ["SVW", "SV Werder Bremen", "云达不莱梅"],
    ["M05", "1. FSV Mainz 05", "美因茨"],
    ["FCA", "FC Augsburg", "奥格斯堡"],
    ["SCF", "SC Freiburg", "弗赖堡"],
    ["BMG", "Borussia Mönchengladbach", "门兴格拉德巴赫"],
    ["SGE", "Eintracht Frankfurt", "法兰克福"],
    ["UNB", "1. FC Union Berlin", "柏林联合"],
    ["SCP", "SC Paderborn 07", "帕德博恩"],
    ["ELV", "SV 07 Elversberg", "埃尔弗斯贝格"],
    ["RBL", "RB Leipzig", "RB莱比锡"],
  ],
  FL1: [
    ["TOU", "Toulouse FC", "图卢兹"],
    ["BRE", "Stade Brestois 29", "布雷斯特"],
    ["MAR", "Olympique de Marseille", "马赛"],
    ["AJA", "AJ Auxerre", "欧塞尔"],
    ["LIL", "Lille OSC", "里尔"],
    ["NIC", "OGC Nice", "尼斯"],
    ["LYO", "Olympique Lyonnais", "里昂"],
    ["PSG", "Paris Saint-Germain FC", "巴黎圣日耳曼"],
    ["FCL", "FC Lorient", "洛里昂"],
    ["REN", "Stade Rennais FC 1901", "雷恩"],
    ["ETR", "ES Troyes AC", "特鲁瓦"],
    ["ANG", "Angers SCO", "昂热"],
    ["HAC", "Le Havre AC", "勒阿弗尔"],
    ["LMF", "Le Mans FC", "勒芒"],
    ["RCL", "Racing Club de Lens", "朗斯"],
    ["ASM", "AS Monaco FC", "摩纳哥"],
    ["RC", "RC Strasbourg Alsace", "斯特拉斯堡"],
    ["PFC", "Paris FC", "巴黎FC"],
  ],
};

const EUROPEAN_LEAGUE_TEAM_CN = Object.keys(EUROPEAN_LEAGUE_TEAM_TRANSLATIONS).reduce(
  (competitions, competitionCode) => {
    const byCode = {};
    const byName = {};
    EUROPEAN_LEAGUE_TEAM_TRANSLATIONS[competitionCode].forEach(([code, name, chineseName]) => {
      byCode[code] = chineseName;
      byName[name] = chineseName;
    });
    competitions[competitionCode] = { byCode, byName };
    return competitions;
  },
  {}
);

export function getWorldCupTeamName(code, name, competitionCode = "WC") {
  const normalizedCompetitionCode = competitionCode ? String(competitionCode).trim().toUpperCase() : "WC";
  const normalizedCode = code ? String(code).trim().toUpperCase() : "";
  const normalizedName = name ? String(name).trim() : "";
  const leagueTeams = EUROPEAN_LEAGUE_TEAM_CN[normalizedCompetitionCode];

  if (leagueTeams) {
    return leagueTeams.byCode[normalizedCode] || leagueTeams.byName[normalizedName] || normalizedName || "待定";
  }

  return WORLD_CUP_TEAM_CN[normalizedCode] || WORLD_CUP_TEAM_NAME_CN[normalizedName] || normalizedName || "待定";
}
